import {
  DELETE_PARTNER_SERVICE_TYPE_FAIL,
  DELETE_PARTNER_SERVICE_TYPE_REQUEST,
  DELETE_PARTNER_SERVICE_TYPE_SUCCESS,
  DETAIL_PARTNER_SERVICE_TYPE_FAIL,
  DETAIL_PARTNER_SERVICE_TYPE_REQUEST,
  DETAIL_PARTNER_SERVICE_TYPE_SET_PRICE_OPTION_FAIL,
  DETAIL_PARTNER_SERVICE_TYPE_SET_PRICE_OPTION_REQUEST,
  DETAIL_PARTNER_SERVICE_TYPE_SET_PRICE_OPTION_SUCCESS,
  DETAIL_PARTNER_SERVICE_TYPE_SUCCESS,
  LIST_PARTNER_SERVICE_TYPE_FAIL,
  LIST_PARTNER_SERVICE_TYPE_REQUEST,
  LIST_PARTNER_SERVICE_TYPE_SUCCESS,
  LIST_SUMMARY_PACKAGE_FAIL,
  LIST_SUMMARY_PACKAGE_REQUEST,
  LIST_SUMMARY_PACKAGE_SUCCESS,
  LIST_SUMMARY_PROJECT_FAIL,
  LIST_SUMMARY_PROJECT_REQUEST,
  LIST_SUMMARY_PROJECT_SUCCESS
} from '../../constants/project-partner'

const initialState = {
  loadingProjectSummary: false,
  loadingPackageSummary: false,
  loadingDeleteServiceType: false,
  loadingDetail: false,
  summaryProject: [],
  summaryPackage: [],
  listServiceType: [],
  detailServiceType: {},
  detailServiceTypeSetPriceOption: {},
  pageable: {
    page: 1,
    size: 10,
    hits: 1
  },
  error: null
}

const projectPartnerReducer = (state = initialState, action) => {
  switch (action.type) {
    case LIST_SUMMARY_PROJECT_REQUEST:
      return {
        ...state,
        loadingProjectSummary: true
      }
    case LIST_SUMMARY_PROJECT_SUCCESS:
      return {
        ...state,
        loadingProjectSummary: false,
        summaryProject: action.payload
      }
    case LIST_SUMMARY_PROJECT_FAIL:
      return {
        ...state,
        loadingProjectSummary: false,
        summaryProject: [],
        error: action.payload
      }
    case LIST_SUMMARY_PACKAGE_REQUEST:
      return {
        ...state,
        loadingPackageSummary: true
      }
    case LIST_SUMMARY_PACKAGE_SUCCESS:
      return {
        ...state,
        loadingPackageSummary: false,
        summaryPackage: action.payload
      }
    case LIST_SUMMARY_PACKAGE_FAIL:
      return {
        ...state,
        loadingPackageSummary: false,
        summaryPackage: [],
        error: action.payload
      }
    case LIST_PARTNER_SERVICE_TYPE_REQUEST:
      return {
        ...state,
        loading: true
      }
    case LIST_PARTNER_SERVICE_TYPE_SUCCESS:
      return {
        ...state,
        loading: false,
        listServiceType: action.payload,
        pageable: action.pageable
      }
    case LIST_PARTNER_SERVICE_TYPE_FAIL:
      return {
        ...state,
        loading: false,
        listServiceType: [],
        pageable: {
          page: 1,
          size: 10
        },
        error: action.payload
      }
    case DETAIL_PARTNER_SERVICE_TYPE_REQUEST:
      return {
        ...state,
        loadingDetail: true
      }
    case DETAIL_PARTNER_SERVICE_TYPE_SUCCESS:
      return {
        ...state,
        loadingDetail: false,
        detailServiceType: action.payload
      }
    case DETAIL_PARTNER_SERVICE_TYPE_FAIL:
      return {
        ...state,
        loadingDetail: false,
        detailServiceType: {},
        error: action.payload
      }
    case DELETE_PARTNER_SERVICE_TYPE_REQUEST:
      return {
        ...state,
        loadingDeleteServiceType: true
      }
    case DELETE_PARTNER_SERVICE_TYPE_SUCCESS:
      return {
        ...state,
        loadingDeleteServiceType: false
      }
    case DELETE_PARTNER_SERVICE_TYPE_FAIL:
      return {
        ...state,
        loadingDeleteServiceType: false
      }
      case DETAIL_PARTNER_SERVICE_TYPE_SET_PRICE_OPTION_REQUEST:
        return {
          ...state,
          loadingDetail: true
        }
      case DETAIL_PARTNER_SERVICE_TYPE_SET_PRICE_OPTION_SUCCESS:
        return {
          ...state,
          loadingDetail: false,
          detailServiceTypeSetPriceOption: action.payload
        }
      case DETAIL_PARTNER_SERVICE_TYPE_SET_PRICE_OPTION_FAIL:
        return {
          ...state,
          loadingDetail: false,
          detailServiceTypeSetPriceOption: {},
          error: action.payload
        }
    default:
      return state
  }
}

export default projectPartnerReducer
